const modes = ['owner', 'admin_view', 'admin_assistance', 'preview', 'unregistered'];

export const validateWorkspace = (value, id) => {
  const invalid = () => { throw new Error('Unable to read this course workspace. Please retry.'); };
  if (!value || !modes.includes(value.mode) || !value.capabilities) invalid();
  if (id && value.workspace_id !== id) invalid();
  if (value.mode !== 'unregistered' && (!value.workspace_id || !value.course || typeof value.course.name !== 'string')) invalid();
  for (const field of ['drafts', 'grants', 'activity', 'bookings', 'events']) {
    if (!Array.isArray(value[field]) || value[field].some(row => !row || typeof row !== 'object')) invalid();
  }
  for (const field of ['can_edit_drafts', 'can_view_financials', 'owner_live_tools', 'gps_pilot']) {
    if (typeof value.capabilities[field] !== 'boolean') invalid();
  }
  return value;
};

export const restrictExpiredAccess = value => {
  if (!value || !['admin_view', 'admin_assistance'].includes(value.mode)) return value;
  const active = expiry => Number.isFinite(Date.parse(expiry)) && Date.parse(expiry) > Date.now();
  return { ...value, capabilities: { ...value.capabilities,
    can_edit_drafts: value.capabilities.can_edit_drafts && active(value.capabilities.edit_expires_at),
    can_view_financials: value.capabilities.can_view_financials && active(value.capabilities.finance_expires_at),
  } };
};